/**
 * Strings do painel do assistente (chat + voz + RGPD).
 * Fallback global: inglês (ASSISTANT_UI.en) via getAssistantUiCopy.
 */

const EN = {
  assistantGreeting: 'Hello! Welcome to WSJ Digital Solutions. How can I help you today?',
  chatPlaceholder: 'Type your message...',
  genericError: 'Sorry, something went wrong. Please try again.',
  micUnavailable: 'Microphone not available',
  micAccessError: 'Microphone access error',
  recordStartError: 'Could not start recording',
  recordingError: 'Recording error',
  noAudioRecorded: 'No audio recorded',
  recordingTooShort: 'Recording is too short. Please speak longer.',
  transcriptionEmpty: 'Could not transcribe the audio',
  transcriptionError: 'Transcription error',
  whatsappCta: 'WhatsApp (Human support)',
  listenReply: 'Listen to reply',
  privacyTitle: 'Privacy & data',
  privacyBody:
    'Before you start, please note that under GDPR this conversation may be recorded for support and service improvement. By continuing, you confirm you have read and accept the terms and privacy policy.',
  privacyCheckbox: 'I have read and accept the terms and privacy policy.',
  privacyAccept: 'Accept and continue',
  privacyLinkPrivacy: 'Privacy Policy',
  privacyLinkTerms: 'Terms',
  privacyLinksHint: 'Dedicated pages coming soon — use this consent to continue.',
  voiceTapToSpeak: 'Tap to speak',
  voiceRequesting: 'Requesting access...',
  voiceRecording: '🔴 Recording... Tap to stop',
  voiceProcessing: 'Processing...',
  voiceSpeaking: '🔊 Playing response...',
  voiceYouSaid: 'You said:',
  voiceAnswerLabel: 'Answer:',
  voiceHintLine1: 'Tap the microphone and ask your question.',
  voiceHintLine2: 'The response will play automatically.'
};

const PT_BR = {
  assistantGreeting: 'Olá! Seja bem-vindo à WSJ Soluções Digitais. Como posso ajudá-lo hoje?',
  chatPlaceholder: 'Digite sua mensagem...',
  genericError: 'Desculpe, ocorreu um erro. Por favor, tente novamente.',
  micUnavailable: 'Microfone não disponível',
  micAccessError: 'Erro ao acessar microfone',
  recordStartError: 'Erro ao iniciar gravação',
  recordingError: 'Erro na gravação',
  noAudioRecorded: 'Nenhum áudio gravado',
  recordingTooShort: 'Gravação muito curta. Fale por mais tempo.',
  transcriptionEmpty: 'Não foi possível transcrever o áudio',
  transcriptionError: 'Erro na transcrição',
  whatsappCta: 'Falar no WhatsApp (Atendimento Humano)',
  listenReply: 'Ouvir resposta',
  privacyTitle: 'Privacidade e dados',
  privacyBody:
    'Antes de começar a conversa, gostaríamos de informar que, de acordo com o Regulamento Geral de Proteção de Dados (RGPD), esta conversa poderá ser registada para fins de atendimento e melhoria do serviço. Ao continuar, você declara que leu e aceita os termos e a política de privacidade.',
  privacyCheckbox: 'Li e aceito os termos e a política de privacidade.',
  privacyAccept: 'Aceitar e continuar',
  privacyLinkPrivacy: 'Política de Privacidade',
  privacyLinkTerms: 'Termos',
  privacyLinksHint: 'Páginas dedicadas em breve — use este aceite para continuar.',
  voiceTapToSpeak: 'Toque para falar',
  voiceRequesting: 'Solicitando acesso...',
  voiceRecording: '🔴 Gravando... Toque para parar',
  voiceProcessing: 'Processando...',
  voiceSpeaking: '🔊 Reproduzindo resposta...',
  voiceYouSaid: 'Você disse:',
  voiceAnswerLabel: 'Resposta:',
  voiceHintLine1: 'Toque no microfone e fale sua pergunta.',
  voiceHintLine2: 'A resposta será reproduzida automaticamente.'
};

const PT_PT = {
  assistantGreeting: 'Olá! Bem-vindo à WSJ Soluções Digitais. Como posso ajudá-lo hoje?',
  chatPlaceholder: 'Escreva a sua mensagem...',
  genericError: 'Desculpe, ocorreu um erro. Por favor, tente novamente.',
  micUnavailable: 'Microfone indisponível',
  micAccessError: 'Erro ao aceder ao microfone',
  recordStartError: 'Erro ao iniciar a gravação',
  recordingError: 'Erro na gravação',
  noAudioRecorded: 'Não foi gravado áudio',
  recordingTooShort: 'Gravação demasiado curta. Fale durante mais tempo.',
  transcriptionEmpty: 'Não foi possível transcrever o áudio',
  transcriptionError: 'Erro na transcrição',
  whatsappCta: 'WhatsApp (Atendimento humano)',
  listenReply: 'Ouvir resposta',
  privacyTitle: 'Privacidade e dados',
  privacyBody:
    'Antes de iniciar, informamos que, ao abrigo do RGPD, esta conversa pode ser registada para apoio e melhoria do serviço. Ao continuar, declara que leu e aceita os termos e a política de privacidade.',
  privacyCheckbox: 'Li e aceito os termos e a política de privacidade.',
  privacyAccept: 'Aceitar e continuar',
  privacyLinkPrivacy: 'Política de privacidade',
  privacyLinkTerms: 'Termos',
  privacyLinksHint: 'Páginas dedicadas em breve — use este consentimento para continuar.',
  voiceTapToSpeak: 'Toque para falar',
  voiceRequesting: 'A pedir acesso...',
  voiceRecording: '🔴 A gravar... Toque para parar',
  voiceProcessing: 'A processar...',
  voiceSpeaking: '🔊 A reproduzir a resposta...',
  voiceYouSaid: 'Disse:',
  voiceAnswerLabel: 'Resposta:',
  voiceHintLine1: 'Toque no microfone e faça a sua pergunta.',
  voiceHintLine2: 'A resposta será reproduzida automaticamente.'
};

const ES = {
  assistantGreeting: '¡Hola! Bienvenido a WSJ Soluciones Digitales. ¿Cómo puedo ayudarte hoy?',
  chatPlaceholder: 'Escribe tu mensaje...',
  genericError: 'Lo siento, ocurrió un error. Inténtalo de nuevo.',
  micUnavailable: 'Micrófono no disponible',
  micAccessError: 'Error al acceder al micrófono',
  recordStartError: 'Error al iniciar grabación',
  recordingError: 'Error en la grabación',
  noAudioRecorded: 'No se grabó audio',
  recordingTooShort: 'La grabación es muy corta. Habla por más tiempo.',
  transcriptionEmpty: 'No fue posible transcribir el audio',
  transcriptionError: 'Error de transcripción',
  whatsappCta: 'WhatsApp (Atención humana)',
  listenReply: 'Escuchar respuesta',
  privacyTitle: 'Privacidad y datos',
  privacyBody:
    'Antes de empezar, informamos que, de acuerdo con el RGPD, esta conversación puede registrarse para atención y mejora del servicio. Al continuar, declaras haber leído y aceptar los términos y la política de privacidad.',
  privacyCheckbox: 'He leído y acepto los términos y la política de privacidad.',
  privacyAccept: 'Aceptar y continuar',
  privacyLinkPrivacy: 'Política de privacidad',
  privacyLinkTerms: 'Términos',
  privacyLinksHint: 'Páginas dedicadas próximamente — usa este consentimiento para continuar.',
  voiceTapToSpeak: 'Toca para hablar',
  voiceRequesting: 'Solicitando acceso...',
  voiceRecording: '🔴 Grabando... Toca para detener',
  voiceProcessing: 'Procesando...',
  voiceSpeaking: '🔊 Reproduciendo respuesta...',
  voiceYouSaid: 'Dijiste:',
  voiceAnswerLabel: 'Respuesta:',
  voiceHintLine1: 'Toca el micrófono y haz tu pregunta.',
  voiceHintLine2: 'La respuesta se reproducirá automáticamente.'
};

const FR = {
  assistantGreeting: 'Bonjour ! Bienvenue chez WSJ Solutions Numériques. Comment puis-je vous aider aujourd’hui ?',
  chatPlaceholder: 'Saisissez votre message...',
  genericError: 'Désolé, une erreur s’est produite. Veuillez réessayer.',
  micUnavailable: 'Microphone indisponible',
  micAccessError: 'Erreur d’accès au microphone',
  recordStartError: 'Impossible de démarrer l’enregistrement',
  recordingError: 'Erreur d’enregistrement',
  noAudioRecorded: 'Aucun audio enregistré',
  recordingTooShort: 'Enregistrement trop court. Parlez plus longtemps.',
  transcriptionEmpty: 'Impossible de transcrire l’audio',
  transcriptionError: 'Erreur de transcription',
  whatsappCta: 'WhatsApp (prise en charge humaine)',
  listenReply: 'Écouter la réponse',
  privacyTitle: 'Confidentialité et données',
  privacyBody:
    'Avant de commencer, sachez qu’en application du RGPD, cette conversation peut être enregistrée pour le support et l’amélioration du service. En continuant, vous confirmez avoir lu et accepté les conditions et la politique de confidentialité.',
  privacyCheckbox: 'J’ai lu et j’accepte les conditions et la politique de confidentialité.',
  privacyAccept: 'Accepter et continuer',
  privacyLinkPrivacy: 'Politique de confidentialité',
  privacyLinkTerms: 'Conditions',
  privacyLinksHint: 'Pages dédiées bientôt — utilisez ce consentement pour continuer.',
  voiceTapToSpeak: 'Appuyez pour parler',
  voiceRequesting: 'Demande d’accès...',
  voiceRecording: '🔴 Enregistrement... Appuyez pour arrêter',
  voiceProcessing: 'Traitement...',
  voiceSpeaking: '🔊 Lecture de la réponse...',
  voiceYouSaid: 'Vous avez dit :',
  voiceAnswerLabel: 'Réponse :',
  voiceHintLine1: 'Appuyez sur le microphone et posez votre question.',
  voiceHintLine2: 'La réponse sera lue automatiquement.'
};

const IT = {
  assistantGreeting: 'Ciao! Benvenuto in WSJ Soluzioni Digitali. Come posso aiutarti oggi?',
  chatPlaceholder: 'Scrivi il tuo messaggio...',
  genericError: 'Spiacenti, si è verificato un errore. Riprova.',
  micUnavailable: 'Microfono non disponibile',
  micAccessError: 'Errore di accesso al microfono',
  recordStartError: 'Impossibile avviare la registrazione',
  recordingError: 'Errore di registrazione',
  noAudioRecorded: 'Nessun audio registrato',
  recordingTooShort: 'Registrazione troppo breve. Parla più a lungo.',
  transcriptionEmpty: 'Impossibile trascrivere l’audio',
  transcriptionError: 'Errore di trascrizione',
  whatsappCta: 'WhatsApp (supporto umano)',
  listenReply: 'Ascolta la risposta',
  privacyTitle: 'Privacy e dati',
  privacyBody:
    'Prima di iniziare, ti informiamo che, ai sensi del GDPR, questa conversazione può essere registrata per assistenza e miglioramento del servizio. Continuando, dichiari di aver letto e accettato i termini e l’informativa sulla privacy.',
  privacyCheckbox: 'Ho letto e accetto i termini e l’informativa sulla privacy.',
  privacyAccept: 'Accetta e continua',
  privacyLinkPrivacy: 'Informativa sulla privacy',
  privacyLinkTerms: 'Termini',
  privacyLinksHint: 'Pagine dedicate in arrivo — usa questo consenso per continuare.',
  voiceTapToSpeak: 'Tocca per parlare',
  voiceRequesting: 'Richiesta accesso...',
  voiceRecording: '🔴 Registrazione... Tocca per fermare',
  voiceProcessing: 'Elaborazione...',
  voiceSpeaking: '🔊 Riproduzione risposta...',
  voiceYouSaid: 'Hai detto:',
  voiceAnswerLabel: 'Risposta:',
  voiceHintLine1: 'Tocca il microfono e fai la tua domanda.',
  voiceHintLine2: 'La risposta verrà riprodotta automaticamente.'
};

const HI = {
  assistantGreeting: 'नमस्ते! WSJ डिजिटल सॉल्यूशंस में आपका स्वागत है। मैं आज आपकी कैसे मदद कर सकता हूँ?',
  chatPlaceholder: 'अपना संदेश लिखें...',
  genericError: 'क्षमा करें, कुछ गलत हो गया। कृपया पुनः प्रयास करें।',
  micUnavailable: 'माइक्रोफ़ोन उपलब्ध नहीं',
  micAccessError: 'माइक्रोफ़ोन एक्सेस में त्रुटि',
  recordStartError: 'रिकॉर्डिंग शुरू नहीं हो सकी',
  recordingError: 'रिकॉर्डिंग त्रुटि',
  noAudioRecorded: 'कोई ऑडियो रिकॉर्ड नहीं हुआ',
  recordingTooShort: 'रिकॉर्डिंग बहुत छोटी है। कृपया अधिक समय तक बोलें।',
  transcriptionEmpty: 'ऑडियो ट्रांसक्राइब नहीं हो सका',
  transcriptionError: 'ट्रांसक्रिप्शन त्रुटि',
  whatsappCta: 'व्हाट्सऐप (मानव सहायता)',
  listenReply: 'उत्तर सुनें',
  privacyTitle: 'गोपनीयता और डेटा',
  privacyBody:
    'शुरू करने से पहले, कृपया ध्यान दें कि GDPR के तहत इस बातचीत को सहायता और सेवा सुधार के लिए रिकॉर्ड किया जा सकता है। जारी रखकर, आप पुष्टि करते हैं कि आपने नियम और गोपनीयता नीति पढ़ ली है और स्वीकार करते हैं।',
  privacyCheckbox: 'मैंने नियम और गोपनीयता नीति पढ़ ली है और स्वीकार करता/करती हूँ।',
  privacyAccept: 'स्वीकार करें और जारी रखें',
  privacyLinkPrivacy: 'गोपनीयता नीति',
  privacyLinkTerms: 'नियम',
  privacyLinksHint: 'समर्पित पृष्ठ जल्द ही — जारी रखने के लिए इस सहमति का उपयोग करें।',
  voiceTapToSpeak: 'बोलने के लिए टैप करें',
  voiceRequesting: 'पहुँच का अनुरोध...',
  voiceRecording: '🔴 रिकॉर्डिंग... रोकने के लिए टैप करें',
  voiceProcessing: 'प्रोसेसिंग...',
  voiceSpeaking: '🔊 उत्तर चल रहा है...',
  voiceYouSaid: 'आपने कहा:',
  voiceAnswerLabel: 'उत्तर:',
  voiceHintLine1: 'माइक्रोफ़ोन पर टैप करें और अपना प्रश्न पूछें।',
  voiceHintLine2: 'उत्तर स्वचालित रूप से बजेगा।'
};

const DE = {
  assistantGreeting: 'Hallo! Willkommen bei WSJ Digital Solutions. Wie kann ich Ihnen heute helfen?',
  chatPlaceholder: 'Nachricht eingeben…',
  genericError: 'Entschuldigung, es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
  micUnavailable: 'Mikrofon nicht verfügbar',
  micAccessError: 'Fehler beim Mikrofonzugriff',
  recordStartError: 'Aufnahme konnte nicht gestartet werden',
  recordingError: 'Aufnahmefehler',
  noAudioRecorded: 'Kein Audio aufgenommen',
  recordingTooShort: 'Aufnahme zu kurz. Bitte sprechen Sie länger.',
  transcriptionEmpty: 'Audio konnte nicht transkribiert werden',
  transcriptionError: 'Transkriptionsfehler',
  whatsappCta: 'WhatsApp (menschlicher Support)',
  listenReply: 'Antwort anhören',
  privacyTitle: 'Datenschutz & Daten',
  privacyBody:
    'Bevor Sie beginnen: Gemäß DSGVO kann diese Gespräch zur Nutzerbetreuung und -verbesserung aufgezeichnet werden. Mit dem Fortfahren bestätigen Sie, dass Sie die Datenschutzrichtlinie und die Bedingungen gelesen und akzeptiert haben.',
  privacyCheckbox: 'Ich habe die Bedingungen und die Datenschutzrichtlinie gelesen und akzeptiere sie.',
  privacyAccept: 'Akzeptieren und fortfahren',
  privacyLinkPrivacy: 'Datenschutzrichtlinie',
  privacyLinkTerms: 'Bedingungen',
  privacyLinksHint: 'Eigene Seiten folgen — nutzen Sie diese Einwilligung zum Fortfahren.',
  voiceTapToSpeak: 'Tippen zum Sprechen',
  voiceRequesting: 'Zugriff wird angefragt…',
  voiceRecording: '🔴 Aufnahme… Tippen zum Stoppen',
  voiceProcessing: 'Wird verarbeitet…',
  voiceSpeaking: '🔊 Antwort wird wiedergegeben…',
  voiceYouSaid: 'Sie sagten:',
  voiceAnswerLabel: 'Antwort:',
  voiceHintLine1: 'Tippen Sie auf das Mikrofon und stellen Sie Ihre Frage.',
  voiceHintLine2: 'Die Antwort wird automatisch abgespielt.'
};

const NL = {
  assistantGreeting: 'Hallo! Welkom bij WSJ Digital Solutions. Hoe kan ik u vandaag helpen?',
  chatPlaceholder: 'Typ uw bericht…',
  genericError: 'Sorry, er is iets misgegaan. Probeer het opnieuw.',
  micUnavailable: 'Microfoon niet beschikbaar',
  micAccessError: 'Fout bij microfoontoegang',
  recordStartError: 'Opname kon niet starten',
  recordingError: 'Opnamefout',
  noAudioRecorded: 'Geen audio opgenomen',
  recordingTooShort: 'Opname te kort. Spreek langer.',
  transcriptionEmpty: 'Audio kon niet worden getranscribeerd',
  transcriptionError: 'Transcriptiefout',
  whatsappCta: 'WhatsApp (menselijke support)',
  listenReply: 'Antwoord beluisteren',
  privacyTitle: 'Privacy & gegevens',
  privacyBody:
    'Voordat u begint: onder de AVG kan dit gesprek worden opgenomen voor ondersteuning en verbetering van de dienst. Door verder te gaan bevestigt u dat u de voorwaarden en het privacybeleid heeft gelezen en accepteert.',
  privacyCheckbox: 'Ik heb de voorwaarden en het privacybeleid gelezen en ga ermee akkoord.',
  privacyAccept: 'Accepteren en doorgaan',
  privacyLinkPrivacy: 'Privacybeleid',
  privacyLinkTerms: 'Voorwaarden',
  privacyLinksHint: 'Dedicated pagina’s volgen — gebruik deze toestemming om door te gaan.',
  voiceTapToSpeak: 'Tik om te spreken',
  voiceRequesting: 'Toegang aanvragen…',
  voiceRecording: '🔴 Opname… Tik om te stoppen',
  voiceProcessing: 'Verwerken…',
  voiceSpeaking: '🔊 Antwoord afspelen…',
  voiceYouSaid: 'U zei:',
  voiceAnswerLabel: 'Antwoord:',
  voiceHintLine1: 'Tik op de microfoon en stel uw vraag.',
  voiceHintLine2: 'Het antwoord wordt automatisch afgespeeld.'
};

const RU = {
  assistantGreeting: 'Здравствуйте! Добро пожаловать в WSJ Digital Solutions. Чем могу помочь сегодня?',
  chatPlaceholder: 'Введите сообщение…',
  genericError: 'Извините, произошла ошибка. Попробуйте снова.',
  micUnavailable: 'Микрофон недоступен',
  micAccessError: 'Ошибка доступа к микрофону',
  recordStartError: 'Не удалось начать запись',
  recordingError: 'Ошибка записи',
  noAudioRecorded: 'Аудио не записано',
  recordingTooShort: 'Запись слишком короткая. Говорите дольше.',
  transcriptionEmpty: 'Не удалось расшифровать аудио',
  transcriptionError: 'Ошибка транскрипции',
  whatsappCta: 'WhatsApp (живая поддержка)',
  listenReply: 'Прослушать ответ',
  privacyTitle: 'Конфиденциальность и данные',
  privacyBody:
    'Перед началом: в соответствии с GDPR этот разговор может записываться для поддержки и улучшения сервиса. Продолжая, вы подтверждаете, что прочитали и принимаете условия и политику конфиденциальности.',
  privacyCheckbox: 'Я прочитал(а) и принимаю условия и политику конфиденциальности.',
  privacyAccept: 'Принять и продолжить',
  privacyLinkPrivacy: 'Политика конфиденциальности',
  privacyLinkTerms: 'Условия',
  privacyLinksHint: 'Отдельные страницы скоро — используйте это согласие для продолжения.',
  voiceTapToSpeak: 'Нажмите, чтобы говорить',
  voiceRequesting: 'Запрос доступа…',
  voiceRecording: '🔴 Запись… Нажмите, чтобы остановить',
  voiceProcessing: 'Обработка…',
  voiceSpeaking: '🔊 Воспроизведение ответа…',
  voiceYouSaid: 'Вы сказали:',
  voiceAnswerLabel: 'Ответ:',
  voiceHintLine1: 'Нажмите на микрофон и задайте вопрос.',
  voiceHintLine2: 'Ответ воспроизведётся автоматически.'
};

const AR = {
  assistantGreeting: 'مرحباً! أهلاً بك في WSJ للحلول الرقمية. كيف يمكنني مساعدتك اليوم؟',
  chatPlaceholder: 'اكتب رسالتك…',
  genericError: 'عذراً، حدث خطأ. يرجى المحاولة مرة أخرى.',
  micUnavailable: 'الميكروفون غير متاح',
  micAccessError: 'خطأ في الوصول إلى الميكروفون',
  recordStartError: 'تعذّر بدء التسجيل',
  recordingError: 'خطأ في التسجيل',
  noAudioRecorded: 'لم يُسجَّل أي صوت',
  recordingTooShort: 'التسجيل قصير جداً. يُرجى التحدث لفترة أطول.',
  transcriptionEmpty: 'تعذّر نسخ الصوت إلى نص',
  transcriptionError: 'خطأ في النسخ',
  whatsappCta: 'واتساب (دعم بشري)',
  listenReply: 'استمع إلى الرد',
  privacyTitle: 'الخصوصية والبيانات',
  privacyBody:
    'قبل البدء: بموجب اللائحة العامة لحماية البيانات (GDPR) قد يُسجَّل هذا الحديث لدعم المستخدم وتحسين الخدمة. بالمتابعة، تؤكد أنك قرأت وتوافق على الشروط وسياسة الخصوصية.',
  privacyCheckbox: 'لقد قرأت الشروط وسياسة الخصوصية وأوافق عليها.',
  privacyAccept: 'قبول ومتابعة',
  privacyLinkPrivacy: 'سياسة الخصوصية',
  privacyLinkTerms: 'الشروط',
  privacyLinksHint: 'صفحات مخصصة قريباً — استخدم هذا الموافقة للمتابعة.',
  voiceTapToSpeak: 'اضغط للتحدث',
  voiceRequesting: 'جارٍ طلب الإذن…',
  voiceRecording: '🔴 جارٍ التسجيل… اضغط للإيقاف',
  voiceProcessing: 'جارٍ المعالجة…',
  voiceSpeaking: '🔊 جارٍ تشغيل الرد…',
  voiceYouSaid: 'قلتَ:',
  voiceAnswerLabel: 'الرد:',
  voiceHintLine1: 'اضغط على الميكروفون واطرح سؤالك.',
  voiceHintLine2: 'سيتم تشغيل الرد تلقائياً.'
};

const ZH_CN = {
  assistantGreeting: '您好！欢迎使用 WSJ 数字解决方案。今天我能为您做些什么？',
  chatPlaceholder: '输入您的消息…',
  genericError: '抱歉，出了点问题。请重试。',
  micUnavailable: '麦克风不可用',
  micAccessError: '无法访问麦克风',
  recordStartError: '无法开始录音',
  recordingError: '录音错误',
  noAudioRecorded: '未录制音频',
  recordingTooShort: '录音太短，请多说一些。',
  transcriptionEmpty: '无法将音频转为文字',
  transcriptionError: '转写错误',
  whatsappCta: 'WhatsApp（人工客服）',
  listenReply: '收听回复',
  privacyTitle: '隐私与数据',
  privacyBody:
    '开始前请知悉：根据 GDPR，本对话可能会被录制用于客服与改进服务。继续即表示您已阅读并同意条款与隐私政策。',
  privacyCheckbox: '我已阅读并同意条款与隐私政策。',
  privacyAccept: '同意并继续',
  privacyLinkPrivacy: '隐私政策',
  privacyLinkTerms: '条款',
  privacyLinksHint: '专用页面即将上线 — 请通过本同意继续。',
  voiceTapToSpeak: '点击说话',
  voiceRequesting: '正在请求权限…',
  voiceRecording: '🔴 录音中… 点击停止',
  voiceProcessing: '处理中…',
  voiceSpeaking: '🔊 正在播放回复…',
  voiceYouSaid: '您说：',
  voiceAnswerLabel: '回复：',
  voiceHintLine1: '点击麦克风并提出您的问题。',
  voiceHintLine2: '回复将自动播放。'
};

const ZH_TW = {
  assistantGreeting: '您好！歡迎使用 WSJ 數位解決方案。今天我能為您做些什麼？',
  chatPlaceholder: '輸入您的訊息…',
  genericError: '抱歉，發生錯誤。請再試一次。',
  micUnavailable: '麥克風無法使用',
  micAccessError: '無法存取麥克風',
  recordStartError: '無法開始錄音',
  recordingError: '錄音錯誤',
  noAudioRecorded: '未錄製音訊',
  recordingTooShort: '錄音太短，請多說一些。',
  transcriptionEmpty: '無法將音訊轉成文字',
  transcriptionError: '轉寫錯誤',
  whatsappCta: 'WhatsApp（真人客服）',
  listenReply: '收聽回覆',
  privacyTitle: '隱私與資料',
  privacyBody:
    '開始前請知悉：依 GDPR，本對話可能會被錄製以提供客服與改善服務。繼續即表示您已閱讀並同意條款與隱私權政策。',
  privacyCheckbox: '我已閱讀並同意條款與隱私權政策。',
  privacyAccept: '同意並繼續',
  privacyLinkPrivacy: '隱私權政策',
  privacyLinkTerms: '條款',
  privacyLinksHint: '專用頁面即將上線 — 請透過此同意以繼續。',
  voiceTapToSpeak: '點擊說話',
  voiceRequesting: '正在請求權限…',
  voiceRecording: '🔴 錄音中… 點擊停止',
  voiceProcessing: '處理中…',
  voiceSpeaking: '🔊 正在播放回覆…',
  voiceYouSaid: '您說：',
  voiceAnswerLabel: '回覆：',
  voiceHintLine1: '點擊麥克風並提出您的問題。',
  voiceHintLine2: '回覆將自動播放。'
};

const ASSISTANT_UI = {
  pt: PT_BR,
  ptPT: PT_PT,
  en: EN,
  es: ES,
  fr: FR,
  it: IT,
  hi: HI,
  de: DE,
  nl: NL,
  ru: RU,
  ar: AR,
  'zh-CN': ZH_CN,
  'zh-TW': ZH_TW
};

/**
 * Resolve copy for the assistant panel. Falls back to English.
 * @param {string} locale - e.g. pt-BR, pt-PT, en, es, fr, zh-CN
 */
export function getAssistantUiCopy(locale) {
  if (!locale) return EN;
  if (locale === 'pt-BR') return ASSISTANT_UI.pt;
  if (locale === 'pt-PT') return ASSISTANT_UI.ptPT;
  if (ASSISTANT_UI[locale]) return ASSISTANT_UI[locale];
  const short = String(locale).split('-')[0].toLowerCase();
  if (ASSISTANT_UI[short]) return ASSISTANT_UI[short];
  return EN;
}
